import { useLocalReactionStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import WizardDialog, { WizardModalDialogProps } from "designSystem/components/wizard/WizardDialog";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import WizardStore from "designSystem/components/wizard/WizardStore";
import { createSharedDataSheetsStore } from "./CreateSharedDataSheetsService";
import { CreateSharedDataSheetsWizardStoreContext } from "./CreateSharedDataSheetsWizardStore";
import CreateSharedDataSheetsForm from "./CreateSharedDataSheetsForm";
import { SelectDataSheetsTable } from "./CreateSharedDataSheetsSelectDataSheets";

export const CreateSharedDataSheetsWizard: FunctionComponent<WizardModalDialogProps<WizardStore>> = observer((props) => {
	const {
		actionController,
		onSave,
		onClose,
		...otherProps
	} = props;
	const loc = useLocale();
	// create the local store for child components so that the store can be shared among pages
	const store = useLocalReactionStore(() => createSharedDataSheetsStore(actionController, onClose, onSave, loc));
	const { index } = store || {};

	return (
		<>
			{store && (
				<CreateSharedDataSheetsWizardStoreContext.Provider value={store}>
					<WizardDialog
						{...otherProps}
						contentPadding={index === 0 ? null : 0}
						// do this to prevent the MUI event from disabling the event of Dojo widget, for example, in the case of Form, when we try to select a value from drop-down, 
						// the focus event from MUI would disable the onMouseUp event of FilteringSelect widget
						disableEnforceFocus
						fullHeight
						pages={[CreateSharedDataSheetsForm, SelectDataSheetsTable]}
						store={store}
						supportStepInformation
						width={index === 1 ? 1200 : 720}
					/>
				</CreateSharedDataSheetsWizardStoreContext.Provider>
			)}
		</>
	);
});

export default CreateSharedDataSheetsWizard;